// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import Logo from 'components/atoms/Logo';
import MailIcon from 'assets/images/readed-mail.svg';
import Paragraph from 'components/atoms/Paragraph';
import Link from 'components/atoms/Link';
import Button from 'components/atoms/Button';
import { AuthContext } from 'context/authContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledCardHolder, Card, IconHolder } from './VerificationCard.styles';

function VerificationCard() {
  const history = useNavigate();
  const { onLogout } = useContext(AuthContext);
  const onClick = () => {
    history('/');
  };
  return (
    <StyledCardHolder>
      <Card>
        <Logo white width="92" height="36" center />

        <IconHolder>
          <img src={MailIcon} alt="mail" />
        </IconHolder>
        <Paragraph css="color: var(--white)">
          We are verifying your details. You will receive a confirmation email and you can access your account with the
          link provided in the email.
        </Paragraph>
        <Paragraph css="color: var(--white)">
          For any questions and concerns please <br /> email:{' '}
          <Link href="mailto: brands@veonpay.com">Brands@veonpay.com</Link>
        </Paragraph>
        <Button
          type="primary"
          onClick={() => {
            onClick();
            onLogout();
          }}>
          Log Out
        </Button>
      </Card>
    </StyledCardHolder>
  );
}

export default VerificationCard;
